import React from 'react';
import Icon from './Icon';
import './ui.css';

/**
 * Small status pill. tone: 'gold' | 'muted' | 'lock' | 'live'.
 */
export default function Badge({ tone = 'muted', icon, children }) {
  return (
    <span className={`hive-badge hive-badge-${tone}`}>
      {icon && <Icon name={icon} size={12} strokeWidth={2.4} />}
      {children}
    </span>
  );
}
